import React from 'react';
import { ImageWrapper } from './MediaImage.styles';
import Image from '@/providers/Image';
import useImagePulse from '@/components/image/imagePulseHook';

export interface MediaImageProps {
  image: ImageObjType;
}

const MediaImage = ({ image, ...props }: MediaImageProps) => {
  const { className, containerRef, handleOnCompleted } = useImagePulse();

  return (
    <ImageWrapper className={className} ref={containerRef}>
      <Image
        src={image.imageUrl}
        alt={image.title}
        fill
        placeholder={`data:image/jpeg;base64,${image.blurDataUrl}`}
        fadeInOnBlur
        handleOnCompleted={handleOnCompleted}
      />
    </ImageWrapper>
  );
};

export default MediaImage;
